var _path, _line;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPacketLossIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 12,
    viewBox: "0 0 32 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M9.77373 12C9.48266 12 9.2612 11.8645 9.10934 11.5934C8.95748 11.3223 8.96381 11.0545 9.12832 10.7901L15.3546 0.376859C15.5065 0.12562 15.7216 0 16 0C16.2784 0 16.4935 0.12562 16.6454 0.376859L22.8717 10.7901C23.0362 11.0545 23.0425 11.3223 22.8907 11.5934C22.7388 11.8645 22.5173 12 22.2263 12H9.77373ZM11.1405 10.4132H20.8595H16H11.1405Z",
    fill: "#F36170"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 2.00781,
    y1: 6,
    x2: 30.0078,
    y2: 6,
    stroke: "#F36170",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPacketLossIcon);
export default __webpack_public_path__ + "static/media/packet-loss-icon.03a118d4c53d473fb96e0133b3823846.svg";
export { ForwardRef as ReactComponent };